import React, { Component } from 'react';
import Button from '../Part_Sample/Button';
import Top_Bar from '../Part_Sample/Top_Bar';
import T_C_Reiri_Office from './Terms_and_Conditions/T_C_Reiri_Office';
import T_C_Reiri_Home from './Terms_and_Conditions/T_C_Reiri_Home';
import Privacy_Reiri from './Terms_and_Conditions/Privacy_Reiri';

export default class Terms_and_Conditions extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	handleNext = () => {
		window.localStorage.setItem('is_terms_and_conditions_accepted', 'true');

		let param = {};
		param.from = 'Terms_and_Conditions';
		this.props.content_handler('Find_Controller', param);
	}

	handlePrevious = () => {
		// If app first started, param is undefined, app will crash
		let is_from_system = false;
		if (this.props.param != undefined && this.props.param != null) {
			if (this.props.param.from == 'System') is_from_system = true;
		}

		if (is_from_system) {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			this.props.content_handler("System");
		} else {
			this.props.content_handler('Select_Language');
		}
	}

	render() {
		// Kaiwei 20210504 If app first started, param is undefined, app will crash
		let is_from_system = false;
		if (this.props.param != undefined && this.props.param != null) {
			if (this.props.param.from == 'System') is_from_system = true;
		}

		let wrap_style = {
			textAlign: 'left',
			height: is_from_system ? this.props.height - 84 : this.props.height - 200,
			overflow: 'auto',
		}

		let is_display_button = is_from_system ? false : true;

		return (
			<div style={{ height: this.props.height, width: '100%', textAlign: 'left' }} >
				<Top_Bar
					width={this.props.width}
					title={this.props.receiver.getString('term_cond')}
					left_button_type={'back'}
					handleLeftButton={this.handlePrevious}
				/>
				<div style={{ marginTop: 0, paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}>
					<div style={{ height: is_from_system == 'System' ? this.props.height - 84 : this.props.height - 200, width: this.props.width - 20, textAlign: 'left' }} >
						<div style={wrap_style}>
							<div style={{ display: this.props.receiver.app_model == 'F' ? 'block' : 'none' }}>
								<T_C_Reiri_Office />
							</div>
							<div style={{ display: this.props.receiver.app_model == 'H' ? 'block' : 'none' }}>
								<T_C_Reiri_Home />
							</div>
							<div>
								<Privacy_Reiri />
							</div>
						</div>
					</div>
				</div>

				<div style={{ display: is_display_button ? 'block' : 'none', marginTop: 20, width: this.props.width * 0.9 }}>
					<Button style={{ color: this.props.colours.button_font, width: '100%', padding: 20, borderRadius: 20, margin: 0, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={this.props.colours.button_bg} onClick={this.handleNext}>{this.props.receiver.getString('agree')}</Button>
				</div>
			</div>
		)
	}
}


